// extracted by mini-css-extract-plugin
export default {"container":"Products_container__LZa8i","row":"Products_row__zyudO"};